export default {
  dashboard: "Dashboard",
  employee: {
    overview: "Mitarbeiter",
  },
  category: {
    overview: "Kategorien",
  },
  material: {
    overview: "Materialien",
  },
  machine: {
    overview: "Maschinen",
  },
  supplier: {
    overview: "Lieferanten",
  },
  additionaleffort: {
    overview: "Zusatzleistungen",
  },
  customer: {
    overview: "Kunden",
  },
  project: {
    overview: "Projekte",
    costs: "Mitlaufende Nachkalkulation",
  },
  // Die Tage, die die Mitarbeiter aus der App an die Bauleitung senden.
  daysubmission: "Tagesmeldungen",
  // Liest die Zahl am Eintrag Tagesmeldungen vor: wie viele noch auf die Bauleitung warten.
  daysubmission_open: "{count} offen",
  userposition: {
    overview: "Personalrollen",
  },
  // Pakete haben keinen eigenen Eintrag mehr; sie stehen beim Katalog, aus dem sie bündeln. Die drei
  // Namen sind die Titel dieser Listen im Browser-Tab.
  packet: {
    overview: "Pakete",
    material: "Materialpakete",
    machine: "Maschinenpakete",
    additional_effort: "Zusatzleistungspakete",
  },
  // Bewusst nicht "Abrechnung": dieser Eintrag ist der Assistent zum Abrechnen von
  // Stundenlohnarbeiten, `billing.settings.*` dagegen das SaaS-Abonnement. Beide hießen einmal
  // "Abrechnung"/"Abrechnen" und kollidierten in den Ergebnissen der Befehlspalette.
  invoice: "[[hwi]]",
  // Der globale Dateibrowser. Bewusst nur "Dateien": die Dateireiter der einzelnen Entitäten heißen
  // ebenso, und dies ist dieselbe Sache — nur ohne den Umweg über den Datensatz.
  file: {
    overview: "Dateien",
  },
  personnelplanning: "Personalplanung",
  // Führt auf "Meine Zeiten" — die eigene Woche. Die Freigabe fremder Zeiten und die Auswertung
  // sind eigene, rechtegeschützte Seiten, die von dort aus erreichbar sind.
  timetracking: "Zeiterfassung",
  settings: "Einstellungen",
  logout: "Abmelden",
  // Beschriftet die Schaltfläche in der Kopfleiste, die die Navigation auf Tablets ein- und
  // ausblendet und sie am Schreibtisch auf die Schmalleiste reduziert.
  toggle: "Navigation ein-/ausblenden",
  // Dieselbe Schaltfläche, solange die Navigation ausgeblendet ist und Tagesmeldungen offen sind.
  toggle_open:
    "Navigation ein-/ausblenden, {count} Tagesmeldung offen | Navigation ein-/ausblenden, {count} Tagesmeldungen offen",
  // Benennt die `nav`-Landmarke der Seitenleiste. Dieselben Ziele gibt es auch in der
  // Befehlspalette — "Navigation" allein würde beide in einer Landmarkenliste nicht unterscheiden.
  label: "Hauptnavigation",
  tenant: {
    // Der Firmenblock am oberen Rand der Seitenleiste.
    label: "Angemeldete Firma",
    // Stellt der Statuszeile ("Aktiv", "Kulanzzeitraum", ...) voran, damit sie nicht nackt vorgelesen wird.
    subscription: "Abonnement",
  },
}
